import { motion } from 'framer-motion';
import { ArrowRight, ShoppingCart, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import products from '../../data/products';

const CrossSelling = () => {
  // We take the 3 first products as "featured"
  const featured = products.slice(0, 3);

  return (
    <section className="py-16 sm:py-24 relative overflow-hidden" style={{ background: 'rgba(22, 88, 131, 0.02)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3 text-xs font-bold uppercase tracking-widest" style={{ color: 'var(--accent-blue)' }}>
              <ShieldCheck size={14} /> Matériel Certifié
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold" style={{ color: 'var(--text-primary)' }}>
              Équipez votre entreprise
            </h2>
          </div>
          <Link to="/boutique" className="group flex items-center gap-2 font-semibold hover:gap-3 transition-all" style={{ color: 'var(--accent-green)' }}>
            Voir toute la boutique <ArrowRight size={20} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featured.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ delay: i * 0.1 }}
              style={{ willChange: 'transform, opacity' }}
              className="rounded-3xl overflow-hidden theme-card flex flex-col h-full group"
            >
              <div className="relative aspect-video overflow-hidden bg-white">
                <img 
                  src={p.img} 
                  alt={`Produit ETCS: ${p.name}`} 
                  loading="lazy"
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500" 
                />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-white/90 backdrop-blur-md text-black border border-black/10">
                  {p.category}
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-lg font-bold mb-2" style={{ color: 'var(--text-primary)' }}>{p.name}</h3>
                <p className="text-sm line-clamp-2 mb-6" style={{ color: 'var(--text-secondary)' }}>{p.description}</p>
                <div className="mt-auto flex items-center justify-between">
                  <div className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>{p.price}</div>
                  <Link to={`/boutique/${p.slug}`} className="p-3 rounded-xl transition-colors hover:scale-105 active:scale-95" 
                    style={{ background: 'var(--accent-green)', color: 'black' }}
                    aria-label={`Voir les détails de ${p.name}`}
                  >
                    <ShoppingCart size={18} />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Promo Banner */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          style={{ willChange: 'transform, opacity' }}
          className="mt-16 rounded-[2.5rem] p-8 md:p-12 relative overflow-hidden flex flex-col md:flex-row items-center justify-between gap-8"
          style={{ background: 'linear-gradient(135deg, #165883, #3f782b)' }}
        >
          <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="relative z-10 max-w-xl text-center md:text-left text-black">
            <h3 className="text-2xl md:text-3xl font-black mb-4">Besoin d'un devis personnalisé pour un lot de matériel ?</h3>
            <p className="font-medium opacity-90">Nous proposons des tarifs préférentiels pour les entreprises et les administrations sénégalaises sur les commandes groupées.</p>
          </div>
          <Link to="/contact" className="relative z-10 px-8 py-4 bg-black text-white rounded-2xl font-bold hover:scale-105 active:scale-95 transition-all shadow-xl">
            Demander un devis
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CrossSelling;
